import MobileDetect from 'mobile-detect';

export default device => {
  const detect = new MobileDetect(device);
  return detect.tablet() ? 'Tablet' : detect.mobile() ? 'Mobile' : 'Desktop';
};
